import './App.css';
import {BrowserRouter,Route,Routes } from 'react-router-dom';
import Home from './components/Home';
import Navbar from './components/Navbar';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import AboutPage from './components/About';
import Contact from './components/Contact';
import StarsCanvas from './components/DroneCanvas';
import Footer from './components/Footer'

const App = () => {
    return (
      <BrowserRouter>
        <Navbar/>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/portfolio' element={<Portfolio/>}/>
          <Route path='/services' element={<Services/>}/> 
          <Route path='/contact' element={<Contact/>}/>
          <Route path='/about' element={<AboutPage/>}/>
        </Routes>
        <Footer/>
      </BrowserRouter>
    );
}

export default App;
